import { NewzooToDatabrain } from '@intelligence/utils/constant';
export const LANGUAGE_EN = 'en-US';
export const LANGUAGE_CN = 'zh-CN';

// 开启COS全球域名加速的环境（预发布和正式）
export const COS_USE_ACCELERATE_ENVS = ['pre', 'pro'];

// OverviewCard组件所需const
export const sourceMap = {
  databrain: 'DataBrain',
  appnnie: 'data.ai',
  sensortower: 'Sensor Tower',
  newzoo: NewzooToDatabrain,
  steam: 'Steam',
  pnd: 'NPD',
  hatchet: 'Stream Hatchet',
  mscience: 'M Science',
  viewers: 'Viewers',
  famitsu: 'Famitsu',
  gsd: 'GSD',
  source_steam: 'Steam',
  alinea: 'Alinea',
} as any;

// 是否显示提示图标（白名单）
export const showTipList = [
  'PHeat',
  'PCU',
  'Digital Revenue($)',
  'US Digital Revenue($)',
  'Digital ARPPU($) (US only)',
  'Physical Revenue($)' /* , 'Hours Watched', 'Peak CCV' */,
  'Cumulative Sales of the latest week',
  'Cumulative Revenue of the latest week($)',
];

// 将图片资源 cos 地址替换为 cdn 地址
export const COS_URL_DOMAIN = 'ogdb-bucket-1300342648.cos.ap-singapore.myqcloud.com';
export const CDN_URL_DOMAIN = 'ogdb-cdn.intlgame.cn';

export const DATABRAIN_COS_DOMAIN = 'databrain-1300342648.cos.ap-singapore.myqcloud.com';
export const DATABRAIN_COS_ACCELERATE = 'databrain-1300342648.cos.accelerate.myqcloud.com';
